import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: "/",
      meta: {
        title: "主页"
      },
      name: "主页",
      component: resolve => require(["../views/index.vue"], resolve),
      redirect: "/index",
      children: [
        {
          path: "index",
          meta: {
            title: "首页"
          },
          component: resolve => require(["../views/Home.vue"], resolve),
          name: "首页"
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js